import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  // 用户信息
  userInfo: baseURL + '/trade/app/personal/user/info',
  // 发起人脸认证
  face: baseURL + '/common/app/auth/person/face',
  // 获取人脸认证结果
  faceResult: baseURL + '/common/app/auth/person/result',
};

export default api;
